<template>
  <div class="service-description">
    <h3>服务说明</h3>
    <div class="font" v-html="description"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'description',
  props: {
    description: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped>
.service-description {
  background-color: #fff;
  border-radius: $regular-border-radius;
  padding: 16px 12px;
  margin-bottom: 12px;

  h3 {
    @include font(14px, 19px);

    padding-bottom: 10px;
  }

  .font {
    @include font(11px, 18px, $warning-text-color);

    background-color: $background-color-4;
    border-radius: $regular-border-radius;
    padding: 14px 10px;
  }
}
</style>
